module.exports = __webpack_public_path__ + "static/media/4-2.6bc66870.png";